import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Venues from '../../sections/proposal-request/venues';
import RequestSectionEditor from '../../sections/proposal-request/requestSectionEditor';

/**
 * Router for the proposal request detail area.
 *
 *  /:org/proposal-requests/:id              → redirect to /venues
 *  /:org/proposal-requests/:id/venues       → Venues list + slide-over detail
 *  /:org/proposal-requests/:id/request/:id  → Single request-section editor
 */
class ProposalRequest extends Component {
	render() {
		const { request, venues = [] } = this.props;
		const requestId = this.props.match.params.request;
		const orgId = this.props.orgId || this.props.match.params.organization;

		return (
			<Switch>
			<Route exact path="/:organization/proposal-requests/:request">
				<Redirect to={`/${orgId}/proposal-requests/${requestId}/request/review`} />
			</Route>

				{/* Legacy paths redirect to the new structure */}
				<Route path="/:organization/proposal-requests/:request/overview">
					<Redirect to={`/${orgId}/proposal-requests/${requestId}/venues`} />
				</Route>
				<Route path="/:organization/proposal-requests/:request/details/:tab?">
					{(routeProps) => {
						const tab = routeProps.match.params.tab || 'event';
						return <Redirect to={`/${orgId}/proposal-requests/${requestId}/request/${tab}`} />;
					}}
				</Route>

				<Route path="/:organization/proposal-requests/:request/request/:section">
					<RequestSectionEditor
						request={request}
						requestId={requestId}
						orgId={orgId}
						refreshSectionCounts={this.props.refreshSectionCounts}
					/>
				</Route>

				<Route path="/:organization/proposal-requests/:request/venues">
					<Venues
						request={request}
						venues={venues}
						requestId={requestId}
						orgId={orgId}
						refreshSectionCounts={this.props.refreshSectionCounts}
					/>
				</Route>
			</Switch>
		);
	}
}

export default ProposalRequest;
